import { render, staticRenderFns } from "./Res4.vue?vue&type=template&id=bfd025ba&scoped=true&lang=pug"
import script from "./Res4.vue?vue&type=script&lang=js"
export * from "./Res4.vue?vue&type=script&lang=js"
import style0 from "./Res4.vue?vue&type=style&index=0&id=bfd025ba&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd025ba",
  null
  
)

export default component.exports